import { EComparisonStatus } from '../../repositories/newbuilding-search/entities/get_newbuildings_for_serp/NewbuildingForSerpItem';
import { IApplicationState } from '../../types/redux';
import { getNewbuildingByIdSelector } from './getNewbuildingByIdSelector';

export const getNewbuildingComparisonStatusSelector =
  (newbuildingId: number) =>
  (state: IApplicationState): EComparisonStatus | null | undefined => {
    const nb = getNewbuildingByIdSelector(newbuildingId)(state);

    return nb?.comparisonStatus;
  };
